var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "currentColor",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.825 12.0001L15.3292 9.4959C15.5573 9.26781 15.5573 8.89915 15.3292 8.67106C15.1011 8.44298 14.7325 8.44298 14.5044 8.67106L12.0001 11.1753L9.4959 8.67106C9.26781 8.44298 8.89915 8.44298 8.67106 8.67106C8.44298 8.89915 8.44298 9.26781 8.67106 9.4959L11.1753 12.0001L8.67106 14.5044C8.44298 14.7325 8.44298 15.1011 8.67106 15.3292C8.78481 15.443 8.93415 15.5001 9.08348 15.5001C9.23281 15.5001 9.38215 15.443 9.4959 15.3292L12.0001 12.825L14.5044 15.3292C14.6181 15.443 14.7675 15.5001 14.9168 15.5001C15.0661 15.5001 15.2155 15.443 15.3292 15.3292C15.5573 15.1011 15.5573 14.7325 15.3292 14.5044L12.825 12.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxNegative);
export default __webpack_public_path__ + "static/media/CheckBoxNegative.5ffee9ff794bec2943082cff5c8eedcb.svg";
export { ForwardRef as ReactComponent };